import { autoFormatEnergyValue } from "@solarschools/component-lib/src/utilities/EnergyUnits";
import { autoFormatMassValue } from "../utilities/UnitsAndKeys/MassUnits";
import React, { useEffect, useState, Fragment } from "react";
import LoadingDots from "../LoadingDots/LoadingDots";

const MapDetail = ({
  setSelectedSchool,
  school: {
    siblingCount,
    organisationName,
    organisationSlug,
    siteName,
    slug,
    resourceId,
    resourceName
  },
  api,
}) => {
  const [fetching, setFecthing] = useState(true);
  const [error, setError] = useState(false);
  const [schoolData, setSchoolData] = useState(false);

  const loadSchoolData = async (resourceId) => {
    setFecthing(true);
    try {
      const data = await api.call('sites', 'get', [resourceId]);
      setSchoolData(data);
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setFecthing(false);
    }
  };
  // load the school's summary data when the resourceId changes
  useEffect(() => {
    loadSchoolData(resourceId);
  }, [resourceId]);

  const { weather = {}, summary = {} } = schoolData || {};

  return (
    <div
      className="position-absolute layer-overlay p-3 d-flex flex-column justify-content-between text-white h-100 col-6 col-xl-3 m-0"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        minHeight: 500,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {/* Title And Close Button for the Details View */}
      <div className="mb-5">
        <div className="d-flex flex-row align-items-start justify-content-between">
          <div className="paragraph-tiny text-primary text-uppercase">
            <strong>Quick Look</strong>
          </div>
          <div
            onClick={() => {
              setSelectedSchool(false);
            }}
            className="material-icons"
            style={{ cursor: "pointer" }}
          >
            close
          </div>
        </div>
        <h1 className="h2 h1-xl">{resourceName}</h1>
        <p>
          {[
            schoolData.suburb,
            schoolData.city,
            schoolData.region,
            schoolData.state,
            schoolData.country,
            schoolData.postcode,
          ]
            .filter((part) => !!part)
            .join(", ")}
        </p>
      </div>
      <div
        className={`flex-grow-1 d-flex flex-column align-items-stretch ${
          fetching ? "justify-content-center" : "justify-content-between"
        }`}
      >
        {fetching ? (
          <LoadingDots spinnerClass="bg-primary" />
        ) : (
          <Fragment>
            {weather.temperature ? (
              <div className="d-flex flex-row align-items-stretch justify-ccontent-between">
                <div className="d-flex flex-column align-items-start justify-content-between">
                  <p className="mb-0">{weather.weatherSummary}</p>
                  <div>
                    <h2 className="h3 h3-xl mb-1">
                      {weather.temperature} &deg;C
                    </h2>
                    <p>Current Weather</p>
                  </div>
                </div>
                <div className="p-2">
                  <div className={"weather-icon " + weather.weatherIcon} />
                </div>
              </div>
            ) : null}
            {summary.lifetimeEnergyGenerated ? (
              <div className="d-flex flex-row align-items-stretch justify-ccontent-between">
                <div className="p-2">
                  <i className="fill-white" style={{ width: "70px" }}>
                    <svg
                      width="75px"
                      height="75px"
                      viewBox="0 0 30 30"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M19,30.14H8.47a.38.38,0,1,1,0-.75H19a.38.38,0,1,1,0,.75Z" />
                      <path d="M16.28,30.14H11.41a.38.38,0,0,1-.38-.37V22.83a.38.38,0,0,1,.38-.38h4.87a.38.38,0,0,1,.38.38v6.94A.38.38,0,0,1,16.28,30.14Zm-4.5-.75h4.13V23.2H11.78Z" />
                      <path d="M6.41,23.2H6.3a.38.38,0,0,1-.25-.47L9.8,10.22a.37.37,0,0,1,.46-.25.38.38,0,0,1,.25.47L6.76,22.94A.35.35,0,0,1,6.41,23.2Z" />
                      <path d="M13.75,23.2h0a.38.38,0,0,1-.38-.37l.1-12.5a.39.39,0,0,1,.38-.38.38.38,0,0,1,.37.38l-.1,12.5A.36.36,0,0,1,13.75,23.2Z" />
                      <path d="M21,23.2a.37.37,0,0,1-.36-.27l-3.44-12.5a.37.37,0,0,1,.72-.2l3.44,12.5a.37.37,0,0,1-.26.46Z" />
                      <path d="M22.84,13.48H4.64a.37.37,0,0,1-.38-.37.38.38,0,0,1,.38-.38h18.2a.38.38,0,0,1,.37.38A.37.37,0,0,1,22.84,13.48Z" />
                      <path d="M24.67,17.79H2.87a.38.38,0,0,1,0-.75h21.8a.38.38,0,0,1,0,.75Z" />
                      <path d="M27,23.2H.66A.39.39,0,0,1,.34,23a.37.37,0,0,1,0-.35l5.12-12.5A.39.39,0,0,1,5.78,10H15.94a.38.38,0,0,1,.38.38.37.37,0,0,1-.38.37H6L1.21,22.45H26.4l-3.79-8.91a.37.37,0,0,1,.69-.29l4,9.43a.37.37,0,0,1-.34.52Z" />
                      <path d="M27,23.2H.69A.36.36,0,0,1,.38,23a.37.37,0,0,1,0-.35l5.12-12.5A.39.39,0,0,1,5.81,10H21.69a.37.37,0,0,1,.34.23l5.31,12.5a.37.37,0,0,1-.34.52ZM1.25,22.45H26.43l-5-11.75H6.06Z" />
                      <path d="M24.34,17a.38.38,0,0,1-.37-.31c-.24-1.45,0-2.49.72-3.09A3,3,0,0,1,27,13.06a2.37,2.37,0,0,1-.42-2,2.87,2.87,0,0,1,1.5-1.61A2.5,2.5,0,0,1,26.45,7.9,2.83,2.83,0,0,1,27,5.65a2.66,2.66,0,0,1-2.24-.72,2.75,2.75,0,0,1-.62-2,2.41,2.41,0,0,1-2,.56,3,3,0,0,1-1.79-1.62A2.27,2.27,0,0,1,19,3.31a3.22,3.22,0,0,1-2.62-.55,2.7,2.7,0,0,1-.76,2.29,2.68,2.68,0,0,1-1.89.54,2.34,2.34,0,0,1,.61,2.06c-.25,1-1.37,1.59-2.13,1.88l.67.5a.37.37,0,0,1,.08.52.38.38,0,0,1-.53.08l-1.25-.94A.37.37,0,0,1,11.32,9c.56-.13,2.07-.67,2.3-1.57.19-.74-.56-1.58-1.21-2.16a.37.37,0,0,1-.08-.47.38.38,0,0,1,.45-.17s1.55.51,2.35-.18c.49-.43.63-1.25.41-2.46a.36.36,0,0,1,.18-.39.38.38,0,0,1,.43,0c.42.37,1.7,1.25,2.61.94.56-.2.95-.84,1.15-1.91a.38.38,0,0,1,.35-.31.39.39,0,0,1,.38.27c.15.51.75,1.89,1.67,2.11.61.13,1.3-.23,2.08-1.07a.37.37,0,0,1,.46-.07.37.37,0,0,1,.18.43s-.45,1.58.29,2.37c.45.48,1.3.6,2.51.34a.38.38,0,0,1,.34.64c-.36.35-1.23,1.44-1,2.3.17.61.87,1.08,2.09,1.38a.38.38,0,0,1,.28.36.38.38,0,0,1-.28.37s-1.67.46-2,1.49c-.16.58.16,1.29.94,2.1a.36.36,0,0,1,0,.46.37.37,0,0,1-.44.15s-1.79-.63-2.67.11c-.5.41-.65,1.22-.46,2.39a.37.37,0,0,1-.31.43Z" />
                    </svg>
                  </i>
                </div>
                <div className="d-flex flex-column align-items-start justify-content-center">
                  <h2 className="h3 h3-xl">
                    {autoFormatEnergyValue(summary.lifetimeEnergyGenerated)}
                  </h2>
                  <div>
                    <p className="mb-0">Lifetime Generation</p>
                    {/* <small>Since School_Start_Date</small> */}
                  </div>
                </div>
              </div>
            ) : null}
            {summary.todayEnergyGenerated ? (
              <div className="d-flex flex-row align-items-stretch justify-ccontent-between">
                <div className="p-2">
                  <i className="fill-white" style={{ width: "70px" }}>
                    <svg
                      width="75px"
                      height="75px"
                      viewBox="0 0 30 30"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M19,30.14H8.47a.38.38,0,1,1,0-.75H19a.38.38,0,1,1,0,.75Z" />
                      <path d="M16.28,30.14H11.41a.38.38,0,0,1-.38-.37V22.83a.38.38,0,0,1,.38-.38h4.87a.38.38,0,0,1,.38.38v6.94A.38.38,0,0,1,16.28,30.14Zm-4.5-.75h4.13V23.2H11.78Z" />
                      <path d="M6.41,23.2H6.3a.38.38,0,0,1-.25-.47L9.8,10.22a.37.37,0,0,1,.46-.25.38.38,0,0,1,.25.47L6.76,22.94A.35.35,0,0,1,6.41,23.2Z" />
                      <path d="M13.75,23.2h0a.38.38,0,0,1-.38-.37l.1-12.5a.39.39,0,0,1,.38-.38.38.38,0,0,1,.37.38l-.1,12.5A.36.36,0,0,1,13.75,23.2Z" />
                      <path d="M21,23.2a.37.37,0,0,1-.36-.27l-3.44-12.5a.37.37,0,0,1,.72-.2l3.44,12.5a.37.37,0,0,1-.26.46Z" />
                      <path d="M22.84,13.48H4.64a.37.37,0,0,1-.38-.37.38.38,0,0,1,.38-.38h18.2a.38.38,0,0,1,.37.38A.37.37,0,0,1,22.84,13.48Z" />
                      <path d="M24.67,17.79H2.87a.38.38,0,0,1,0-.75h21.8a.38.38,0,0,1,0,.75Z" />
                      <path d="M27,23.2H.66A.39.39,0,0,1,.34,23a.37.37,0,0,1,0-.35l5.12-12.5A.39.39,0,0,1,5.78,10H15.94a.38.38,0,0,1,.38.38.37.37,0,0,1-.38.37H6L1.21,22.45H26.4l-3.79-8.91a.37.37,0,0,1,.69-.29l4,9.43a.37.37,0,0,1-.34.52Z" />
                      <path d="M27,23.2H.69A.36.36,0,0,1,.38,23a.37.37,0,0,1,0-.35l5.12-12.5A.39.39,0,0,1,5.81,10H21.69a.37.37,0,0,1,.34.23l5.31,12.5a.37.37,0,0,1-.34.52ZM1.25,22.45H26.43l-5-11.75H6.06Z" />
                      <path d="M24.34,17a.38.38,0,0,1-.37-.31c-.24-1.45,0-2.49.72-3.09A3,3,0,0,1,27,13.06a2.37,2.37,0,0,1-.42-2,2.87,2.87,0,0,1,1.5-1.61A2.5,2.5,0,0,1,26.45,7.9,2.83,2.83,0,0,1,27,5.65a2.66,2.66,0,0,1-2.24-.72,2.75,2.75,0,0,1-.62-2,2.41,2.41,0,0,1-2,.56,3,3,0,0,1-1.79-1.62A2.27,2.27,0,0,1,19,3.31a3.22,3.22,0,0,1-2.62-.55,2.7,2.7,0,0,1-.76,2.29,2.68,2.68,0,0,1-1.89.54,2.34,2.34,0,0,1,.61,2.06c-.25,1-1.37,1.59-2.13,1.88l.67.5a.37.37,0,0,1,.08.52.38.38,0,0,1-.53.08l-1.25-.94A.37.37,0,0,1,11.32,9c.56-.13,2.07-.67,2.3-1.57.19-.74-.56-1.58-1.21-2.16a.37.37,0,0,1-.08-.47.38.38,0,0,1,.45-.17s1.55.51,2.35-.18c.49-.43.63-1.25.41-2.46a.36.36,0,0,1,.18-.39.38.38,0,0,1,.43,0c.42.37,1.7,1.25,2.61.94.56-.2.95-.84,1.15-1.91a.38.38,0,0,1,.35-.31.39.39,0,0,1,.38.27c.15.51.75,1.89,1.67,2.11.61.13,1.3-.23,2.08-1.07a.37.37,0,0,1,.46-.07.37.37,0,0,1,.18.43s-.45,1.58.29,2.37c.45.48,1.3.6,2.51.34a.38.38,0,0,1,.34.64c-.36.35-1.23,1.44-1,2.3.17.61.87,1.08,2.09,1.38a.38.38,0,0,1,.28.36.38.38,0,0,1-.28.37s-1.67.46-2,1.49c-.16.58.16,1.29.94,2.1a.36.36,0,0,1,0,.46.37.37,0,0,1-.44.15s-1.79-.63-2.67.11c-.5.41-.65,1.22-.46,2.39a.37.37,0,0,1-.31.43Z" />
                    </svg>
                  </i>
                </div>
                <div className="d-flex flex-column align-items-start justify-content-center">
                  <h2 className="h3 h3-xl">
                    {autoFormatEnergyValue(summary.todayEnergyGenerated)}
                  </h2>
                  <p>Today's Generation</p>
                </div>
              </div>
            ) : null}
            {summary.lifetimeCo2Saved ? (
              <div className="d-flex flex-row align-items-stretch justify-ccontent-between">
                <div className="p-2">
                  <i className="fill-white" style={{ width: "70px" }}>
                    <svg
                      width="75px"
                      height="75px"
                      viewBox="0 0 30 30"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M14.91,29.64A14.38,14.38,0,1,1,29.29,15.27,14.38,14.38,0,0,1,14.91,29.64Zm0-28A13.63,13.63,0,1,0,28.54,15.27,13.64,13.64,0,0,0,14.91,1.64Z" />
                      <path d="M24.48,25.85a.34.34,0,0,1-.26-.11L4.31,6.09a.39.39,0,0,1,0-.53.38.38,0,0,1,.53,0L24.75,25.21a.38.38,0,0,1,0,.53A.39.39,0,0,1,24.48,25.85Z" />
                      <path d="M19.56,21.67c-2.46,0-5.22,0-5.42,0H7.79a4.18,4.18,0,0,1-3.74-4,3.78,3.78,0,0,1,1.76-3.67,3.67,3.67,0,0,1,3.07-.36,4.26,4.26,0,0,1,4.26-2.65,6.44,6.44,0,0,1,2.93-3.53,5,5,0,0,1,4.21.07,5.45,5.45,0,0,1,3.34,3.09,4.59,4.59,0,0,1-.17,3.2,5.45,5.45,0,0,1,2.61,2.48A3.32,3.32,0,0,1,26,18.91c0,.09-1,2.61-3.27,2.72C22,21.66,20.83,21.67,19.56,21.67Zm-5.42-.79h0c.06,0,6.51.09,8.54,0,1.8-.08,2.61-2.22,2.62-2.24a2.64,2.64,0,0,0,.06-2.13,5,5,0,0,0-2.56-2.23.36.36,0,0,1-.22-.23.34.34,0,0,1,0-.31,4,4,0,0,0,.29-3A4.71,4.71,0,0,0,20,8.15a4.27,4.27,0,0,0-3.59-.1,5.89,5.89,0,0,0-2.63,3.37.39.39,0,0,1-.41.27,3.55,3.55,0,0,0-3.93,2.48.38.38,0,0,1-.55.22,2.76,2.76,0,0,0-2.68.17,3.08,3.08,0,0,0-1.4,3,3.35,3.35,0,0,0,3,3.33Z" />
                      <path d="M16.86,19.24a2.56,2.56,0,0,1-2.39-2.71,2.57,2.57,0,0,1,2.39-2.72,2.57,2.57,0,0,1,2.38,2.72A2.56,2.56,0,0,1,16.86,19.24Zm0-4.68a1.83,1.83,0,0,0-1.64,2,1.83,1.83,0,0,0,1.64,2,1.83,1.83,0,0,0,1.63-2A1.83,1.83,0,0,0,16.86,14.56Z" />
                      <path d="M12.29,19.24a2.56,2.56,0,0,1-2.38-2.71,2.57,2.57,0,0,1,2.38-2.72,2.26,2.26,0,0,1,1.87,1,.38.38,0,0,1-.09.53.39.39,0,0,1-.53-.1,1.51,1.51,0,0,0-1.25-.72,1.82,1.82,0,0,0-1.63,2,1.82,1.82,0,0,0,1.63,2,1.51,1.51,0,0,0,1.19-.62.37.37,0,0,1,.52-.06.36.36,0,0,1,.07.52A2.26,2.26,0,0,1,12.29,19.24Z" />
                      <path d="M21.45,16.32H20.07A.38.38,0,0,1,19.7,16c-.05-.35,0-.54.12-.67a6.14,6.14,0,0,1,.63-.45c.56-.36.56-.52.55-.58a.36.36,0,0,0-.16-.28.42.42,0,0,0-.38-.06.46.46,0,0,0-.2.38.38.38,0,0,1-.75-.09,1.2,1.2,0,0,1,.63-1,1.14,1.14,0,0,1,1.61,1c0,.58-.47,1-.9,1.24l-.08.06h.68a.37.37,0,0,1,.38.37A.38.38,0,0,1,21.45,16.32Zm-1.38-.71h0Z" />
                    </svg>
                  </i>
                </div>
                <div className="d-flex flex-column align-items-start justify-content-center">
                  <h2>{autoFormatMassValue(summary.lifetimeCo2Saved)}</h2>
                  <div>
                    <p className="mb-0">Lifetime C02e Avoided</p>
                    {/* <small>Since School_Start_Date</small> */}
                  </div>
                </div>
              </div>
            ) : null}

            <a
              href={`/schools/${slug}`}
              className="btn btn-primary mt-2 d-block"
            >
              Go to {siblingCount > 0 ? "Site" : "School"} Profile
            </a>
            {siblingCount > 0 ? (
              <a
                href={`/schools/${organisationSlug}`}
                className="btn btn-primary mt-2 d-block"
              >
                Go to Organisation Profile
              </a>
            ) : null}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default MapDetail;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolMap/MapDetail.js